export type Identity = { userId: string; name: string };
const KEY_PREFIX = 'planning-poker:';
const key = (roomId: string) => `${KEY_PREFIX}${roomId}`;

export function loadIdentity(roomId: string): Identity | null {
    try {
        const raw = localStorage.getItem(key(roomId));
        if (!raw) return null;
        const obj = JSON.parse(raw);
        if (typeof obj?.userId === 'string' && typeof obj?.name === 'string') return obj;
        return null;
    } catch { return null; }
}
export function saveIdentity(roomId: string, id: Identity) {
    localStorage.setItem(key(roomId), JSON.stringify(id));
}
export function forgetIdentity(roomId: string) {
    localStorage.removeItem(key(roomId));
}
export function ensureUserId(existing?: string) {
    if (existing?.trim()) return existing;
    if (typeof crypto !== 'undefined' && 'randomUUID' in crypto) return crypto.randomUUID();
    return 'u-' + Math.random().toString(36).slice(2) + Date.now().toString(36);
}